export var ExprFrame;
(function (ExprFrame) {
    let Type;
    (function (Type) {
        Type["Cell"] = "CELL";
        Type["Pane"] = "PANE";
        Type["Table"] = "TABLE";
        Type["Custom"] = "CUSTOM";
    })(Type = ExprFrame.Type || (ExprFrame.Type = {}));
    let Address;
    (function (Address) {
        Address["Down"] = "DOWN";
        Address["Across"] = "ACROSS";
        Address["DownAcross"] = "DOWN_ACROSS";
        Address["AcrossDown"] = "ACROSS_DOWN";
    })(Address = ExprFrame.Address || (ExprFrame.Address = {}));
    let Cell;
    (function (Cell) {
        function make() {
            return { type: "CELL" };
        }
        Cell.make = make;
    })(Cell = ExprFrame.Cell || (ExprFrame.Cell = {}));
    let Pane;
    (function (Pane) {
        function make(address = "DOWN") {
            return { address, type: "PANE" };
        }
        Pane.make = make;
    })(Pane = ExprFrame.Pane || (ExprFrame.Pane = {}));
    let Table;
    (function (Table) {
        function make(address = "DOWN") {
            return { address, type: "TABLE" };
        }
        Table.make = make;
    })(Table = ExprFrame.Table || (ExprFrame.Table = {}));
    let Custom;
    (function (Custom) {
        function make(address = []) {
            return { address, type: "CUSTOM" };
        }
        Custom.make = make;
    })(Custom = ExprFrame.Custom || (ExprFrame.Custom = {}));
})(ExprFrame || (ExprFrame = {}));
